import React from "react";

const MaintenancePage: React.FC = () => (
  <div className="maintenance-page">
    <div className="maintenance-content">
      <img src="/img/logo.png" alt="Rodeo Picks" className="maintenance-logo" />
      <div className="maintenance-badge">SCHEDULED MAINTENANCE</div>
      <h1 className="maintenance-title">We&apos;ll Be Right Back</h1>
      <p className="maintenance-subtitle">
        We&apos;re making some improvements to bring you a better experience.
        The site will be back up shortly.
      </p>
      <div className="maintenance-divider">
        <span></span><span></span><span></span>
      </div>
      <p className="maintenance-footer">Thank you for your patience.</p>
    </div>
  </div>
);

export default MaintenancePage;
